module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/grosseto.3f1a9545c5f8feaafc3fd52ac2a16056.jpg";